import React, {useCallback, useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import qs from "query-string";
import {useLocation, useNavigate} from "react-router-dom";
import Api from "../Api.js";
import {word} from "../word.js";
import {Autocomplete, TextField} from "@mui/material";
import DatePicker from "react-datepicker";
import SearchBar from "../components/SearchBar.js";
import Loader from "../components/BlueButton/Loader.js";
import {useDispatch, useSelector} from "react-redux";
import {accountantRequest, taskCompanyRequest} from "../store/actions/task.js";
import CustomPagination from "../components/BlueButton/CustomPagination.js";
import FileItem from "../components/Files/FileItem.js";
import AddFile from "../components/Files/AddFile.js";

const profession = localStorage.getItem("profession");

function Files(props) {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false)
    const [show, setShow] = useState(false)
    const [submit] = useState(false);

    const [filters, setFilters] = useState({
        created_at: null,
        name: '',
        company: null,

    })
    const organization = useSelector((state) => state.task.companies);

    const [companyFile, setCompanyFiles] = useState({})

    const parseQuery = useCallback(() => qs.parse(location.search), [location.search]);
    useEffect(() => {
        (async () => {
            await dispatch(taskCompanyRequest())
            await dispatch(accountantRequest())
        })();
    }, []);
    const getCompanyFileData = useCallback(async () => {
        setLoader(true)
        const {data} = await Api.getFiles(location.search)
        setCompanyFiles(data)
        setLoader(false)
    }, [location.search,])
    const handleChangeDate = date => {
        const created_at = date ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : null;
        setFilter({created_at});
    };
    const handlePageChange =async (pageNumber) => {
        const offset = pageNumber === 1 ? '' : (pageNumber - 1) * 10;
        await setFilter((prev) => ({ ...prev,offset,page:pageNumber }));
    };
    const setFilter = useCallback(async (newFilter = {}) => {
        const params = parseQuery();
        const tmp = {
            ...params,
            ...newFilter,
        };
        setFilters(tmp)
        const stringify = qs.stringify({...params, ...tmp});
        navigate(`?${stringify}`)
        await getCompanyFileData();
    }, [location.search,]);

    useEffect(() => {
        (async () => {
           await setFilter();
        })()
    }, [location.search,]);

    return (
        <Wrapper>
            <div className="company-files">
                <div className="plus-cont" onClick={() => setShow(true)}>
                    <span className="plus">+</span>
                    <span className="tooltiptext">{word.add_file}</span>
                </div>
                <div className="files-filters">
                    <div className="search-date">
                        <SearchBar value={filters.name} onChange={(value) => setFilter({name: value})}/>
                        <DatePicker
                            dateFormat="dd/MM/yyyy"
                            selected={filters.created_at ? new Date(filters.created_at) : null}
                            popperPlacement="bottom-end"
                            onChange={handleChangeDate}
                        />
                    </div>

                    {profession === "manager" && organization ? (
                        <Autocomplete
                            loading={organization.length === 0}
                            loadingText={
                                <div className="auto-complete-loader">
                                    <Loader size={20}/>
                                </div>
                            }
                            getOptionKey={(option) => option.id}
                            value={organization.find(org => +org.id === +filters.company) || null}
                            options={organization}
                            onChange={(e, value) => {
                                setFilter({company: value ? value.id : ""});
                            }}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}
                                        error={!filters.company && submit}
                                        id={!filters.company && submit? "validation-outlined-input" : "outlined-helperText"}
                                        label="Կազմակերպություններ"
                                        fullWidth
                                    />
                                )
                            }}
                        />
                    ) : null}
                </div>
                <div className="files-cont">
                    {!loader && companyFile?.results?.length ? (
                        companyFile.results.map((item, index) => (
                            <div key={index}>
                                <FileItem
                                    company={item.company_files.name}
                                    file_url={item.file}
                                    name={item.name}
                                    id={item.url}
                                    getCompanyFileData={getCompanyFileData}
                                    date={item.created_at}
                                    url={item.company_files.accountant[0]}
                                />
                            </div>
                        ))
                    ) : loader ?(
                        <div className="loaderMargin">
                            <Loader type="Oval" color="#101C2A" height={30} width={30}/>
                        </div>
                    ):<div className="no_tasks text-center">Ֆայլեր չկան</div>}

                    {companyFile?.count > 10 && !loader && (

                        <div className="d-flex justify-content-center">
                            <CustomPagination
                                currentPage={+filters.offset ? filters.offset / 10 + 1 : 1}
                                totalItems={companyFile.count}
                                itemsPerPage={10}
                                totalPages={Math.ceil(companyFile.count / 10) || 0}
                                onPageChange={(newPage) => handlePageChange(newPage)}
                            />
                        </div>
                    )}
                </div>
                {show?<AddFile getData={async () => await getCompanyFileData(location.search)} open={show} setOpen={setShow}/>:null}
            </div>
        </Wrapper>
    );
}

export default Files;